(function () {
  'use strict';
  if (window.KWCartDrawer) return;

  var SECTION = 'kw-cart-drawer';
  var subs = { opened: [], loaded: [], updated: [] };
  var lastCart = null;

  window.igEvents = window.igEvents || [];

  function fire(list, cart) {
    for (var i = 0; i < list.length; i++) { try { list[i]({ cart: cart }); } catch (e) {} }
  }
  function winEvent(name, detail) {
    try { window.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {}
  }

  var KWCartDrawer = /** @class */ (function (Base) {
    function El() { return Reflect.construct(Base, [], El); }
    El.prototype = Object.create(Base.prototype);
    El.prototype.constructor = El;

    El.prototype.connectedCallback = function () {
      var self = this;
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || this.getAttribute('data-root') || '/';
      if (this.root.slice(-1) !== '/') this.root += '/';
      this.queue = Promise.resolve();
      this.qtyTimers = {};
      this.isOpen = false;
      this.ppActive = false;
      this.insActive = false;
      this.insured = false;
      this.lastFocus = null;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var m = self.querySelector('[data-kwc-ppm].is-open');
        if (m) { m.classList.remove('is-open'); return; }
        if (self.isOpen) self.close();
      });
      document.addEventListener('cart:updated', this.onExternalUpdate.bind(this));
      // any cart change anywhere on the site, including other apps and the PDP
      document.addEventListener('cart:updated', function (e) {
        var c = e && e.detail;
        if (c && typeof c.total_price === 'number') self.checkTiers(c.total_price);
      });

      if (this.getAttribute('data-pp-force') === 'true' || window.IG_PACKAGE_PROTECTION) this.activatePP();
      if (this.getAttribute('data-ins-force') === 'true' || window.IG_INSURANCE) this.activateIns();
      this.checkTiers(parseInt(this.getAttribute('data-cart-total'), 10));
      this.initReserved();
      requestAnimationFrame(function () { self.classList.add('is-ready'); });
      fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { lastCart = c; self.checkTiers(c.total_price); fire(subs.loaded, c); winEvent('aftersell-upcart:public-events:cart-loaded', { cart: c }); })
        .catch(function () {});
    };
    El.prototype.open = function () {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.classList.add('is-open');
      document.body.classList.add('kw-drawer-open', 'upcartPopupShow');
      this._sy = window.scrollY || document.documentElement.scrollTop || 0;
      var bs = document.body.style;
      bs.position = 'fixed'; bs.top = (-this._sy) + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%';
      var panel = this.querySelector('.kwc-panel');
      if (panel) panel.focus({ preventScroll: true });
      window.igEvents.push({ event: 'cart_opened' });
      window.igEvents.push({ event: 'upcart_cart_opened' });
      fire(subs.opened, lastCart);
      winEvent('aftersell-upcart:public-events:cart-opened', { cart: lastCart });
      this.notifyUpsells();
      this.syncPP();
      this.syncIns();
      if (lastCart) this.checkTiers(lastCart.total_price);
      if (this.insActive) this.igPush('insurance_shown');
    };

    El.prototype.close = function () {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      document.body.classList.remove('kw-drawer-open', 'upcartPopupShow');
      var bs = document.body.style;
      bs.position = ''; bs.top = ''; bs.left = ''; bs.right = ''; bs.width = '';
      window.scrollTo(0, this._sy || 0);
      if (this.lastFocus && this.lastFocus.focus) { try { this.lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    };

    El.prototype.notifyUpsells = function () {
      if (this.querySelector('[data-kwc-upsells]')) winEvent('aftersell-upcart:public-events:upsells:rendered', {});
    };
    El.prototype.onClick = function (e) {
      var t = e.target;
      var closer = t.closest('[data-kwc-close]');
      if (closer || t.classList.contains('kwc-overlay')) { e.preventDefault(); this.close(); return; }

      var minus = t.closest('[data-kwc-qty-minus]');
      var plus = t.closest('[data-kwc-qty-plus]');
      if (minus || plus) {
        var box = t.closest('[data-kwc-item]');
        var input = box.querySelector('[data-kwc-qty-input]');
        var q = Math.max(0, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
        input.value = q;
        this.queueQty(box.getAttribute('data-key'), q, box);
        return;
      }

      var rm = t.closest('[data-kwc-remove]');
      if (rm) {
        var item = t.closest('[data-kwc-item]');
        item.classList.add('is-removing');
        this.mutate('cart/change.js', { id: item.getAttribute('data-key'), quantity: 0 });
        return;
      }

      var upsell = t.closest('[data-kwc-upsell-add]');
      if (upsell) { this.addUpsell(upsell); return; }

      var apply = t.closest('[data-kwc-code-apply]');
      if (apply) { this.applyDiscount(); return; }

      var rmCode = t.closest('[data-kwc-code-remove]');
      if (rmCode) { this.removeDiscount(rmCode.getAttribute('data-code')); return; }

      var ppInfo = t.closest('[data-kwc-pp-info]');
      if (ppInfo) {
        e.preventDefault();
        if (this.insActive) this.igPush('insurance_info_opened');
        this.togglePPModal(true);
        return;
      }

      var ppmClose = t.closest('[data-kwc-ppm-close]');
      if (ppmClose) { this.togglePPModal(false); return; }

      var checkout = t.closest('[data-kwc-checkout]');
      if (checkout) {
        if (this.insActive) { e.preventDefault(); this.insCheckout(checkout); return; }
        checkout.classList.add('is-loading'); return; // default nav proceeds
      }

      var ppBtn = t.closest('[data-kwc-pp-checkout]');
      if (ppBtn) { e.preventDefault(); this.protectedCheckout(ppBtn); return; }

      var ppPlain = t.closest('[data-kwc-pp-plain]');
      if (ppPlain) { e.preventDefault(); window.location.href = this.root + 'checkout'; return; }
    };

    El.prototype.onChange = function (e) {
      var t = e.target;
      if (t.matches('[data-kwc-ins-box]')) { this.toggleIns(t.checked); return; }
      if (t.matches('[data-kwc-qty-input]')) {
        var box = t.closest('[data-kwc-item]');
        var q = Math.max(0, parseInt(t.value, 10) || 0);
        t.value = q;
        this.queueQty(box.getAttribute('data-key'), q, box);
      }
      if (t.matches('.kwc-upsell-variant')) {
        var card = t.closest('.kwc-upsell-card');
        card.querySelector('[data-kwc-upsell-add]').setAttribute('data-variant-id', t.value);
      }
    };

    El.prototype.onKeydown = function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-kwc-code-input]')) { e.preventDefault(); this.applyDiscount(); }
      if (e.key !== 'Tab' || !this.isOpen) return;
      var f = this.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    El.prototype.queueQty = function (key, qty, box) {
      var self = this;
      clearTimeout(this.qtyTimers[key]);
      this.qtyTimers[key] = setTimeout(function () {
        if (qty === 0 && box) box.classList.add('is-removing');
        self.mutate('cart/change.js', { id: key, quantity: qty });
      }, 300);
    };

    El.prototype.mutate = function (endpoint, payload, opts) {
      var self = this;
      opts = opts || {};
      payload.sections = SECTION;
      this.queue = this.queue.then(function () {
        self.classList.add('is-busy');
        return fetch(self.root + endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart && cart.token) {           // full cart response (change/update/clear)
              lastCart = cart;
              self.renderFrom(cart.sections);
              self.dispatchCart(cart);
              if (opts.after) opts.after(cart);
            } else if (cart && cart.sections) { // add.js response
              self.renderFrom(cart.sections);
              return self.refreshCartJson(opts.after);
            }
          })
          .catch(function () { return self.refresh(); })
          .then(function () { self.classList.remove('is-busy'); });
      });
      return this.queue;
    };

    El.prototype.refreshCartJson = function (after) {
      var self = this;
      return fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { lastCart = c; self.dispatchCart(c); if (after) after(c); })
        .catch(function () {});
    };

    El.prototype.dispatchCart = function (cart) {
      fire(subs.updated, cart);
      winEvent('aftersell-upcart:public-events:cart-updated', { cart: cart });
      var d = Object.assign({}, cart, { __kw: true });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: d }));
    };
    El.prototype.renderFrom = function (sections) {
      var html = sections && sections[SECTION];
      if (!html) return this.refresh();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-drawer-inner]');
      var current = this.querySelector('[data-drawer-inner]');
      if (!fresh || !current) return;
      var body = this.querySelector('.kwc-body');
      var scroll = body ? body.scrollTop : 0;
      var focusKey = document.activeElement && document.activeElement.matches && document.activeElement.matches('[data-kwc-qty-input]')
        ? document.activeElement.closest('[data-kwc-item]').getAttribute('data-key') : null;
      current.replaceWith(fresh);
      var nb = this.querySelector('.kwc-body');
      if (nb) nb.scrollTop = scroll;
      if (focusKey) {
        var inp = this.querySelector('[data-kwc-item][data-key="' + focusKey + '"] [data-kwc-qty-input]');
        if (inp) inp.focus({ preventScroll: true });
      }
      this.notifyUpsells();
      this.syncPP();
      this.syncIns();
      if (lastCart) this.checkTiers(lastCart.total_price);
      this.initReserved();
    };
    El.prototype.initReserved = function () {
      var el = this.querySelector('[data-kwc-reserved]');
      if (this._resTimer) { clearInterval(this._resTimer); this._resTimer = null; }
      if (!el) return;
      var target = el.querySelector('[data-kwc-reserved-time]');
      if (!target) return;
      var mins = parseInt(el.getAttribute('data-minutes'), 10) || 15;
      var span = mins * 60000;
      var end = 0;
      try { end = parseInt(sessionStorage.getItem('kwcReserveEnd'), 10) || 0; } catch (e) {}
      var save = function (v) { try { sessionStorage.setItem('kwcReserveEnd', String(v)); } catch (e) {} };
      if (end <= Date.now()) { end = Date.now() + span; save(end); }
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) { end = Date.now() + span; save(end); left = span; }
        var s = Math.floor(left / 1000);
        var mm = Math.floor(s / 60);
        var ss = s % 60;
        target.textContent = mm + ':' + (ss < 10 ? '0' : '') + ss;
      };
      tick();
      this._resTimer = setInterval(tick, 1000);
    };

    El.prototype.refresh = function () {
      var self = this;
      return fetch(this.root + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (s) { self.renderFrom(s); })
        .catch(function () {});
    };

    El.prototype.onExternalUpdate = function (e) {
      var d = e.detail || {};
      if (d.__kw) return;
      if (d.token) lastCart = d;
      if (d.sections && d.sections[SECTION]) { this.renderFrom(d.sections); return; }
      if (window.__kwSections && window.__kwSections[SECTION]) {
        var s = window.__kwSections; window.__kwSections = null;
        this.renderFrom(s); return;
      }
      this.refresh();
    };
    El.prototype.addUpsell = function (btn) {
      btn.disabled = true;
      this.mutate('cart/add.js', { id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 });
    };
    El.prototype.appliedCodes = function (cart) {
      var out = [];
      var list = (cart && cart.discount_codes) || [];
      for (var i = 0; i < list.length; i++) if (list[i].applicable) out.push(list[i].code);
      return out;
    };

    El.prototype.applyDiscount = function () {
      var self = this;
      var input = this.querySelector('[data-kwc-code-input]');
      var err = this.querySelector('[data-kwc-code-error]');
      var btn = this.querySelector('[data-kwc-code-apply]');
      if (!input || !input.value.trim()) return;
      var code = input.value.trim();
      if (err) err.hidden = true;
      if (btn) btn.disabled = true;
      var codes = this.appliedCodes(lastCart); codes.push(code);
      this.mutate('cart/update.js', { discount: codes.join(',') }, { after: function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) {
          return d.applicable && d.code.toLowerCase() === code.toLowerCase();
        });
        if (!ok) {
          var keep = self.appliedCodes(cart).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
          self.mutate('cart/update.js', { discount: keep.join(',') }).then(function () {
            var e2 = self.querySelector('[data-kwc-code-error]');
            var i2 = self.querySelector('[data-kwc-code-input]');
            var b2 = self.querySelector('[data-kwc-code-apply]');
            if (e2) e2.hidden = false;
            if (i2) i2.value = code;
            if (b2) b2.disabled = false;
          });
        }
      } });
    };

    El.prototype.removeDiscount = function (code) {
      var keep = this.appliedCodes(lastCart).filter(function (c) { return c.toLowerCase() !== String(code).toLowerCase(); });
      this.mutate('cart/update.js', { discount: keep.join(',') });
    };
    El.prototype.activatePP = function () {
      this.ppActive = true;
      this.classList.add('kwc-pp-active');
      this.syncPP();
    };

    El.prototype.togglePPModal = function (open) {
      var m = this.querySelector('[data-kwc-ppm]');
      if (m) m.classList.toggle('is-open', !!open);
    };

    El.prototype.syncPP = function () {
      var pp = this.querySelector('[data-kwc-pp]');
      if (!pp) return;
      if (this.ppActive) pp.hidden = false;
      var vid = this.getAttribute('data-pp-variant');
      var plain = this.querySelector('[data-kwc-pp-plain]');
      if (plain && vid && lastCart && lastCart.items) {
        var has = lastCart.items.some(function (it) { return String(it.variant_id) === String(vid); });
        plain.style.display = has ? 'none' : '';
      }
    };

    El.prototype.protectedCheckout = function (btn) {
      var self = this;
      if (btn.classList.contains('is-loading')) return; // preloader running, ignore re-fires
      var vid = parseInt(this.getAttribute('data-pp-variant'), 10);
      btn.classList.add('is-loading');
      function go() { window.location.href = self.root + 'checkout'; }
      if (!vid) return go();
      fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = (cart.items || []).find(function (it) { return it.variant_id === vid; });
          if (!line) return fetch(self.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) });
          if (line.quantity !== 1) return fetch(self.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 1 }) });
        })
        .then(go).catch(go); // fail-open to checkout
    };

    /* ---------- cart value tiers ---------- */

    // Intelligems custom events are sticky (counted if triggered at least once) and its
    // filters are OR-only, with no exclusion. So exclusive bands cannot be expressed as
    // events. These are cumulative thresholds measured against the session PEAK cart
    // value, which only ever goes up, so each fires at most once and never contradicts
    // itself. Derive exclusive bands by subtracting cohorts in analysis.
    El.prototype.checkTiers = function (totalCents) {
      if (typeof totalCents !== 'number' || isNaN(totalCents) || totalCents < 0) return;

      // Defaults matter: if only the JS file gets deployed and the section is stale,
      // data-tiers is missing and this would otherwise go permanently silent.
      var tiers = [];
      var raw = (this.getAttribute('data-tiers') || '').split(',');
      for (var i = 0; i < raw.length; i++) {
        var v = parseInt(raw[i], 10);
        if (!isNaN(v) && v > 0) tiers.push(v);
      }
      if (!tiers.length) tiers = [2500, 5500, 8500];
      tiers.sort(function (a, b) { return a - b; });

      var peak = 0, fired = 0;
      try {
        peak  = parseInt(sessionStorage.getItem('kwcCartPeak') || '0', 10) || 0;
        fired = parseInt(sessionStorage.getItem('kwcTiersFired') || '0', 10) || 0;
      } catch (e) {}
      if (totalCents > peak) {
        peak = totalCents;
        try { sessionStorage.setItem('kwcCartPeak', String(peak)); } catch (e) {}
      }

      for (var t = fired; t < tiers.length; t++) {
        if (peak < tiers[t]) break;
        var name = 'cart_over_' + Math.round(tiers[t] / 100);
        this.igPush(name, { peak: peak / 100 });
        if (window.KWC_DEBUG) console.log('[kwc] tier fired:', name, 'peak', peak / 100);
        fired = t + 1;
      }
      try { sessionStorage.setItem('kwcTiersFired', String(fired)); } catch (e) {}
    };

    /* ---------- insurance checkbox test ---------- */

    El.prototype.igPush = function (name, extra) {
      var p = { event: name };
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
      try { (window.igEvents = window.igEvents || []).push(p); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push(p); } catch (e) {}
    };

    El.prototype.activateIns = function () {
      if (this.ppActive) return;           // forced protected checkout wins, never both surfaces
      this.insActive = true;
      this.classList.add('kwc-ins-active');
      this.syncIns();
    };

    El.prototype.insInCart = function () {
      var vid = parseInt(this.getAttribute('data-pp-variant'), 10);
      if (!vid || !lastCart || !lastCart.items) return false;
      return lastCart.items.some(function (it) { return it.variant_id === vid; });
    };

    // Runs on open and after every re-render, so it has to rebuild state from scratch.
    El.prototype.syncIns = function () {
      if (!this.insActive) return;
      var box = this.querySelector('[data-kwc-ins-box]');
      if (!box) return;
      var saved = null;
      try { saved = sessionStorage.getItem('kwcInsured'); } catch (e) {}
      // already paid for it wins, then the shopper's own last choice, else off
      this.insured = this.insInCart() || saved === '1';
      box.checked = this.insured;
      this.paintIns();
    };

    El.prototype.paintIns = function () {
      var on = this.insured;
      var card = this.querySelector('[data-kwc-ins-card]');
      if (card) card.classList.toggle('is-on', on);
      // The card sits in the product list, so the fee belongs in the subtotal.
      // That makes the drawer match what Shopify checkout will show line for line.
      var sub = this.querySelector('[data-kwc-sub]');
      if (sub) sub.textContent = sub.getAttribute(on ? 'data-sub-on' : 'data-sub-plain') || sub.textContent;
      var lbl = this.querySelector('[data-kwc-co-label]');
      if (lbl) lbl.textContent = lbl.getAttribute(on ? 'data-label-on' : 'data-label-plain') || lbl.textContent;
    };

    El.prototype.toggleIns = function (on) {
      this.insured = !!on;
      try { sessionStorage.setItem('kwcInsured', on ? '1' : '0'); } catch (e) {}
      this.paintIns();
      this.igPush(on ? 'insurance_checked' : 'insurance_unchecked');
      // if it is physically in the cart already and they opted out, take it back off now
      if (!on && this.insInCart()) this.insWrite(0, '');
    };

    // One cart write, carrying both the line and the attribution.
    // Toggling never touches the network, which keeps the drawer instant and stops
    // Shopify's Clear-Site-Data response headers spamming the console on every tap.
    // Attribution is a cart attribute, not a line-item property: properties change the
    // line key, which would stop the line merging with anything PDQ or PPU adds and
    // could put two protection lines on one order. The leading underscore hides it
    // from the customer at checkout. Never use two, that makes it unreadable.
    El.prototype.insWrite = function (qty, tag) {
      var vid = parseInt(this.getAttribute('data-pp-variant'), 10);
      var body = {};
      if (vid && qty !== null) {
        body.updates = {};
        body.updates[vid] = qty;                     // absolute quantity, cannot double-add
      }
      body.attributes = { _pp_source: tag || '' };
      return fetch(this.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    };

    El.prototype.insCheckout = function (btn) {
      var self = this;
      if (btn.classList.contains('is-loading')) return;   // re-entry guard, not the disabled attr
      btn.classList.add('is-loading');
      this.igPush(this.insured ? 'insurance_checkout_insured' : 'insurance_checkout_plain');
      function go() { window.location.href = self.root + 'checkout'; }
      var vid = parseInt(this.getAttribute('data-pp-variant'), 10);
      var want = this.insured ? 1 : 0;
      var has = this.insInCart();
      var tag = this.insured ? 'cart_checkbox' : '';
      if (!vid || (want === 0 && !has)) return go();          // nothing to record, nothing to write
      var qty = (want === 1 && has) ? null : want;            // already correct? attribute only
      this.insWrite(qty, tag).then(go).catch(function () { self.igPush('insurance_write_failed'); go(); });
    };

    return El;
  })(HTMLElement);

  customElements.define('kw-cart-drawer', KWCartDrawer);
  function el() { return document.getElementById('kw-cart-drawer'); }
  window.upcartOpenCart = function () { var d = el(); if (d) d.open(); };
  window.upcartCloseCart = function () { var d = el(); if (d) d.close(); };
  window.upcartRefreshCart = function () { var d = el(); if (d) d.refresh(); };
  window.upcartGetCart = function () { return lastCart; };
  window.upcartSubscribeCartOpened = function (fn) { subs.opened.push(fn); };
  window.upcartSubscribeCartLoaded = function (fn) { subs.loaded.push(fn); if (lastCart) { try { fn({ cart: lastCart }); } catch (e) {} } };
  window.upcartSubscribeCartUpdated = function (fn) { subs.updated.push(fn); };
  window.igPackageProtection = function () { var d = el(); if (d) d.activatePP(); };
  window.igInsurance = function () { var d = el(); if (d) d.activateIns(); };

  // Console helper. The tier events fire once per session, so if you are testing and
  // see nothing, you have most likely already fired them. Reset and re-check:
  //   KWC_DEBUG = true; kwcTiers.reset(); kwcTiers.check()
  window.kwcTiers = {
    state: function () {
      var d = el();
      var out = { peak: null, fired: null, tiers: d ? d.getAttribute('data-tiers') : null,
                  igEventsPresent: !!window.igEvents };
      try {
        out.peak = sessionStorage.getItem('kwcCartPeak');
        out.fired = sessionStorage.getItem('kwcTiersFired');
      } catch (e) {}
      return out;
    },
    reset: function () {
      try { sessionStorage.removeItem('kwcCartPeak'); sessionStorage.removeItem('kwcTiersFired'); } catch (e) {}
      return 'tier session state cleared';
    },
    check: function () {
      var d = el(); if (!d) return 'drawer not found';
      var t = lastCart && typeof lastCart.total_price === 'number'
        ? lastCart.total_price
        : parseInt(d.getAttribute('data-cart-total'), 10);
      d.checkTiers(t);
      return { checkedAgainst: t, state: this.state() };
    }
  };
  Object.defineProperty(window, 'KWCartDrawer', { get: el });
})();
